.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-8) var(--tempest-space-4);
    text-align: center;
    font-family: var(--tempest-font-sans);
}

.icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: var(--tempest-radius-full);
    background-color: var(--tempest-danger-bg);
    color: var(--tempest-danger);
}

.title {
    margin: 0;
    font-size: var(--tempest-text-lg);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
}

.description {
    margin: 0;
    font-size: var(--tempest-text-base);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-normal);
    max-width: 480px;
}

.action {
    margin-top: var(--tempest-space-2);
}
